import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Cache across component mounts so we don't hit /api/installations/stats
// multiple times per page load. Refreshes every 5 min.
let _cache = { total: null, states: 0, cities: 0, ts: 0 };
let _pending = null;

const FIVE_MIN = 5 * 60 * 1000;

async function fetchStats() {
  const now = Date.now();
  if (_cache.total !== null && now - _cache.ts < FIVE_MIN) return _cache;
  if (_pending) return _pending;
  _pending = (async () => {
    try {
      const { data } = await api.get("/installations/stats");
      _cache = {
        total: data.total || 0,
        states: (data.states || []).length,
        cities: (data.top_cities || []).length,
        ts: Date.now(),
      };
      return _cache;
    } catch {
      return _cache; // keep prior/default
    } finally {
      _pending = null;
    }
  })();
  return _pending;
}

/**
 * Marketing-friendly rounded install count.
 * 11,807 → "11,500+"  ·  10,143 → "10,000+"
 * Always rounds DOWN to nearest 500 so we never over-claim.
 */
export function useInstallCount(fallback = 10000) {
  const [total, setTotal] = useState(_cache.total ?? fallback);
  useEffect(() => {
    fetchStats().then((s) => {
      if (s.total !== null && s.total !== total) setTotal(s.total);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const rounded = Math.floor(total / 500) * 500;
  const label = rounded.toLocaleString("en-IN") + "+";
  return { total, rounded, label };
}
